import { NotFoundIcon } from '../../utils/svg';
import useNavigation from '../../hook/useNavigation';

const NotFound = () => {
	const navigate = useNavigation();
	return (
		<div className={`flex h-screen w-full justify-center items-center bg-white`}>
			<div className='relative h-screen w-full max-w-lg'>
				<div className='flex justify-center items-center h-full flex-col'>
					<NotFoundIcon className={`fill-[var(--rose-violet)]`} />
					<div className='mt-5 text-gray-700 font-semibold text-center'>Tidak Dapat Diproses</div>
					<div className='text-center mt-2 text-xs text-gray-700'>
						Kami tidak dapat memproses permintaan Anda saat ini.
						<br />
						Silakan coba lagi nanti.
					</div>
					<button type='button' className={`bg-[var(--rose-violet)] text-white mt-8 w-fit flex justify-between font-normal text-sm py-3 px-16 items-center border-0`} onClick={() => navigate.push('/')}>
						Kembali
					</button>
				</div>
			</div>
		</div>
	);
};

export default NotFound;
